module.exports = __webpack_public_path__ + "img/IMG_0731.ccf67d15.jpeg";